import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { mapMutations } from 'vuex';
export default {
  props: {
    themeColor: {
      type: String,
      default: ''
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      policySearchCheckedList: [],
      orderSearchCheckedList: [],
      policySearchCondition: '',
      orderSearchCondition: '',
      smsModal: false,
      //短信弹窗
      code: '' //验证码
    };
  },
  mounted() {
    console.log(this.styleObj, 'this.styleObj');
    this.$nextTick(() => {
      var _this$styleObj, _this$styleObj2;
      // 保单搜索条件
      this.policySearchCheckedList = (_this$styleObj = this.styleObj) === null || _this$styleObj === void 0 || (_this$styleObj = _this$styleObj.policySearch) === null || _this$styleObj === void 0 ? void 0 : _this$styleObj.searchTerms.map(item => {
        if (item.termDisplay == true) {
          return item.termValue;
        }
      });
      // 订单搜索条件
      this.orderSearchCheckedList = (_this$styleObj2 = this.styleObj) === null || _this$styleObj2 === void 0 || (_this$styleObj2 = _this$styleObj2.orderSearch) === null || _this$styleObj2 === void 0 ? void 0 : _this$styleObj2.searchTerms.map(item => {
        if (item.termDisplay) {
          return item.termValue;
        }
      });
    });
  },
  computed: {
    queryInfoActiveTab: {
      get() {
        console.log('==================== queryInfoActiveTab === get ====================');
        console.log(this.$store.state.control.queryInfoActiveTab, 'this.$store.state.control.queryInfoActiveTab');
        return this.$store.state.control.queryInfoActiveTab;
      },
      set(val) {
        console.log('==================== queryInfoActiveTab === set ====================');
        console.log(val, 'val');
        this.$store.commit('control/SET_QUERY_INFO_ACTIVE_TAB', val);
      }
    }
  },
  methods: {
    ...mapMutations({
      SET_QUERY_INFO_ACTIVE_TAB: 'control/SET_QUERY_INFO_ACTIVE_TAB'
    }),
    selectChange(type, val) {
      console.log('==================== selectChange ====================');
      console.log(val, 'val');
      if (type === 'policy') {
        this.policySearchCondition = val;
      } else if (type === 'order') {
        this.orderSearchCondition = val;
      }
    },
    search(type) {
      console.log(type, 'type');
      if (type == 'policy' && this.policySearchCondition == '手机号查询') {
        if (this.styleObj.policySearch.searchTerms[0].sendSMS == true) {
          this.smsModal = true;
        }
      } else if (type == 'order' && this.orderSearchCondition == '手机号查询') {
        if (this.styleObj.orderSearch.searchTerms[0].sendSMS == true) {
          this.smsModal = true;
        }
      }
    },
    closeModal() {
      this.smsModal = false;
      this.code = '';
    }
  }
};